import { FETCH_OFFER_SUCCESS } from 'constants/offers';
import { FETCH_PAYMENT_SUCCESS } from 'constants/payment';
import type { Field } from 'models/field';
import { combineReducers } from 'redux';

export type OffersActionType =
  | typeof FETCH_OFFER_SUCCESS
  | typeof FETCH_PAYMENT_SUCCESS;
type OffersAction = {
  type: OffersActionType;
  payload: {
    entities: {
      fields: Record<string, Field>;
    };
  };
};

export const byId = (
  state: Record<string, Field> = {},
  action: OffersAction,
) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return fields;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: OffersAction) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { fields = {} },
      } = action.payload;
      return Object.keys(fields);
    default:
      return state;
  }
};

const offers = combineReducers({ byId, ids });

export { offers };
